<template>
  <div class="home">
    <login />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "./Login.vue";

export default {
  name: "Home",
  components: {
    Login,
  },
};
</script>
